// On Mouse Hover Show drop down Menu
document.addEventListener('DOMContentLoaded', function () {
  let items = document.querySelectorAll("header header-menu");
  items.forEach(item => {
    item.addEventListener("mouseover", function() {
        const details = this.querySelector('details')
        details.setAttribute("open", true);
        item.querySelector("ul")?.addEventListener("mouseleave", function () {
          //item.removeAttribute("open");
        });
    });
  
    item.addEventListener("mouseleave", function () {
      const details = this.querySelector('details')
        details.removeAttribute("open");
    });
  
  });
})


// jazbah modules

// show message
function showMessage(){
  setTimeout(()=>{
    const msgBox = document.querySelector(".fs-cart-popup");

    msgBox.classList.add("active");

    setTimeout(()=>{
      msgBox.classList.remove("active");
    }, 10000);
  }, 2000);
}

async function fetchCart() {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart");
    return await response.json();
  } catch (error) {
    console.error("Error fetching cart:", error);
    return null;
  }
}

// Add a product to cart
async function addToCart(variantId, quantity = 1) {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity,
      }),
    });
    if (!response.ok) throw new Error("Failed to add to cart");
    return await response.json();
  } catch (error) {
    console.error("Error adding to cart:", error);
    return null;
  }
}

// Remove a product from cart (by line item key)
async function removeFromCart(lineItemKey, quantity) {
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: quantity,
      }),
    });
    if (!response.ok) throw new Error("Failed to remove item");
    return await response.json();
  } catch (error) {
    console.error("Error removing from cart:", error);
    return null;
  }
}

// form
function updateForm(p_id, v_id, form, bundleQuantity){
  const product_id_input = form.querySelector(`input[name="product-id"]`);
  const variant_id_input = form.querySelector(`input[name="id"]`);
  const quantity_input = document.querySelector(`.product-form__quantity quantity-input input[name="quantity"]`)
  const atc = form.querySelector(`button[type="submit"]`);
  product_id_input.value = p_id;
  variant_id_input.value = v_id;
  if(quantity_input && bundleQuantity) quantity_input.value = bundleQuantity;

  setTimeout(()=>{
    atc.click();
  }, 500);
}

// product add to cart
function productAtc(bundle, product, crntProductHandle, form, products){
  const bundleQuantity = Number(document.querySelector(`.product-form__quantity quantity-input input[name="quantity"]`)?.value);

  if(bundle && product){
    const productQuantity = product.quantity;
    const bundleIds = productIds[bundle.bundle];
    const singleProductHandle = bundle.products.find((item)=> item !== product.handle);
    const singleProductIds = productIds[singleProductHandle];

    if(productQuantity >= bundleQuantity){
      removeFromCart(product.key, productQuantity - bundleQuantity);
      updateForm(bundleIds.p_id, bundleIds.v_id, form, bundleQuantity);
    } else {
      if(product.handle === "ice-barrel-chiller"){
        removeFromCart(product.key, 0);

        const singleProductQuantity = bundleQuantity - productQuantity;
        addToCart(singleProductIds.v_id, singleProductQuantity);

        updateForm(bundleIds.p_id, bundleIds.v_id, form, productQuantity - bundleQuantity);
      } else {
        let avaiableQuantity = bundleQuantity - productQuantity;

        products.forEach((new_product)=>{
          if(new_product !== product && avaiableQuantity > 0){
            if(avaiableQuantity >= new_product.quantity){
              removeFromCart(new_product.key, 0);
              addToCart(bundleIds.v_id, new_product.quantity);
              avaiableQuantity = avaiableQuantity - new_product.quantity;
            } else {
              removeFromCart(new_product.key, new_product.quantity - avaiableQuantity);
              addToCart(bundleIds.v_id, avaiableQuantity);
              avaiableQuantity = avaiableQuantity - new_product.quantity;
            }
          }
        });

        if(avaiableQuantity > 0){
          addToCart(singleProductIds.v_id, avaiableQuantity);
        }

        removeFromCart(product.key, 0);
        updateForm(bundleIds.p_id, bundleIds.v_id, form, productQuantity);

        console.log(bundleQuantity, productQuantity, avaiableQuantity);
      }
    }

    showMessage();
  } else {
    const bundleIds = productIds[crntProductHandle];
    updateForm(bundleIds.p_id, bundleIds.v_id, form)
  }
}

// bundles 
const bundles = [
  {
    bundle: "ice-barrel-300-bundle",
    products: [
      "ice-barrel-300",
      "ice-barrel-chiller",
    ]
  },
  {
    bundle: "ice-barrel-400-bundle",
    products: [
      "ice-barrel-400",
      "ice-barrel-chiller",
    ]
  },
  {
    bundle: "ice-barrel-500-bundle",
    products: [
      "ice-barrel-500",
      "ice-barrel-chiller",
    ]
  }
]

const productIds = {
  "ice-barrel-chiller": {
    p_id: 7175954006083,
    v_id: 41446842073155,
  },
  "ice-barrel-300": {
    p_id: 7165024927811,
    v_id: 41431018963011,
  },
  "ice-barrel-400": {
    p_id: 7174674645059,
    v_id: 41444562337859,
  },
  "ice-barrel-500": {
    p_id: 7174677790787,
    v_id: 41444566663235,
  },
  "ice-barrel-300-bundle": {
    p_id: 7442531156035,
    v_id: 42387813105731,
  },
  "ice-barrel-400-bundle": {
    p_id: 7442531057731,
    v_id: 42387812843587,
  },
  "ice-barrel-500-bundle": {
    p_id: 7441039917123,
    v_id: 42383541010499,
  },
};

class FsBuyButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", async () => {
      const crntProductHandle = this.getAttribute("product-handle");
      const cart = await fetchCart();
      const form = this.closest(`form[action="/cart/add"] `);
      
      if (cart) {
        if (crntProductHandle === "ice-barrel-chiller") {
          const barrel = cart.items.find(item => item.handle === "ice-barrel-300" || item.handle === "ice-barrel-400" || item.handle === "ice-barrel-500");
          const barrels = cart.items.filter(item => item.handle === "ice-barrel-300" || item.handle === "ice-barrel-400" || item.handle === "ice-barrel-500");
          const bundle = bundles.find(bundle => bundle.products.includes(barrel?.handle));
          
          productAtc(bundle, barrel, crntProductHandle, form, barrels);
        } else {
          const bundle = bundles.find(bundle => bundle.products.includes(crntProductHandle));
          const chiller = cart.items.find(item => item.handle === "ice-barrel-chiller");

          productAtc(bundle, chiller, crntProductHandle, form);
        }
      }
    });
  }
}

if (!customElements.get("fs-buy-button")) {
  customElements.define("fs-buy-button", FsBuyButton);
}

class FsInfinitySlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: "auto",
            loop: true,
            speed: 2000,
            autoplay: {
                delay: 0,
            },
            spaceBetween: 0,
            pagination: {
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
}

if(!customElements.get('fs-infinity-slider')){
    customElements.define('fs-infinity-slider', FsInfinitySlider);
}


class DynamicWidthSlider extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.swiper = null;
    this.desktopGap = 24;
    this.desktopSlides = 3;

    if (window.innerWidth >= 992) {
      this.deviceType = "desktop";
    }

    this.initSlider();

    window.addEventListener(
      "resize",
      () => {
        this.updateSlideWidths();

        if (this.deviceType === "desktop" && window.innerWidth < 992) {
          this.deviceType = "mobile";
          this.swiper?.update();
        } else if (this.deviceType === "mobile" && window.innerWidth >= 992) {
          this.deviceType = "desktop";
          this.swiper?.update();
        }
      },
      {
        signal: this.#controller.signal,
      }
    );
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  initSlider() {
    if (!this.sliderEl) return;

    this.swiper = new Swiper(this.sliderEl, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      speed: 600,
      loop: true,
      noSwiping: false,
        navigation: {
          nextEl: '.fs_bestseller .fs_swiper-button-next',
          prevEl: '.fs_bestseller .fs_swiper-button-prev',
        },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 16,
          noSwiping: false
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
          noSwiping: true
        },
      },
      on: {
        init: () => {
          this.updateSlideWidths();
        },
        update: () => {
          this.updateSlideWidths();
        },
        slideChangeTransitionEnd: () => {
          this.swiper?.update();
        },
      },
    });
  }

  updateSlideWidths() {
    if (window.innerWidth < 992) return;

    if(this.timer) clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.querySelectorAll(".swiper-slide").forEach((slide, index) => {
        if (index === this.swiper.activeIndex) {
          slide.style.minWidth = `${(this.slideWidth * 3) / 2}px`;
          slide.style.maxWidth = `${(this.slideWidth * 3) / 2}px`;
        } else if (
          index === this.swiper.activeIndex + 1 ||
          index === this.swiper.activeIndex + 2
        ) {
          slide.style.minWidth = `${(this.slideWidth * 3) / 4}px`;
          slide.style.maxWidth = `${(this.slideWidth * 3) / 4}px`;
        } else {
          slide.style.minWidth = `${this.slideWidth}px`;
          slide.style.maxWidth = `${this.slideWidth}px`;
        }
      });
    }, 60);
  }

  destroySlider() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  get sliderEl() {
    return this.querySelector("[data-slider]");
  }

  get sliderWidth() {
    return this.sliderEl?.offsetWidth || this.offsetWidth;
  }

  get slideWidth() {
    const widthWithoutGaps =
      this.sliderWidth - this.desktopGap * (this.desktopSlides - 1);
    return widthWithoutGaps / this.desktopSlides;
  }
}

if (!customElements.get("dynamic-width-slider")) {
  customElements.define("dynamic-width-slider", DynamicWidthSlider);
}

// 
// cookie
function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }

    return null;
}


var cookiesarr = [
    "_uc_visits", "_uc_utm_term", "_uc_utm_campaign", "_uc_utm_source",
    "_uc_current_session", "_uc_utm_medium", "_uc_utm_content", "_uc_last_referrer", "_uc_initial_landing_page", "_uc_referrer"
];

var html = "";
cookiesarr.forEach(myFunction);
function myFunction(value, index, array) {
    const myCookieValue = getCookie(value);
    if (myCookieValue != "" && myCookieValue != null)
        html += '<input type="hidden" name="attributes[' + value + ']" value="' + myCookieValue + '">';
    else
        html += '<input type="hidden" name="attributes[' + value + ']" value="N/A">';
}


function findElementByClassWithTimer(className, timeout) {
    const intervalTime = 1000; // Check every 1 second
    let elapsedTime = 0;

    return new Promise((resolve, reject) => {
        const intervalId = setInterval(() => {
            elapsedTime += intervalTime;
            const elements = document.getElementsByClassName(className);

            if (elements.length > 0) {
                // Class found, clear the interval and resolve with the first element
                clearInterval(intervalId);
                resolve(elements[0]);
            }

            if (elapsedTime >= timeout) {
                // Timeout reached, clear the interval and reject
                clearInterval(intervalId);
                reject(new Error('Timeout: Class not found within the specified timeout.'));
            }
        }, intervalTime);
    });
}

// Example usage
const classNameToFind = 'hidden_notes';
const timeout = 100000000; // 1 seconds timeout

findElementByClassWithTimer(classNameToFind, timeout)
    .then((foundElement) => {
        // console.log('Class found:', foundElement);
        const elements = document.getElementsByClassName('hidden_notes');
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const inputs = doc.querySelectorAll('input');

        const plainText = Array.from(inputs).map(input => `${input.name}: ${input.value}`).join('\n');

        updateCartNote(plainText);

        for (let i = 0; i < elements.length; i++) {
            elements[i].innerHTML = html;
        }
    })
    .catch((error) => {
        console.log(error.message);
    });


async function updateCartNote(noteText) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: noteText })
    });

    if (!response.ok) throw new Error('Failed to update cart note');

    const data = await response.json();
    console.log('Cart updated:');
    return data;
  } catch (error) {
    console.error('Error updating cart note:', error);
    return null;
  }
}

class FsDetails extends HTMLElement {
  constructor() {
    super();

    this.accordions = [
      ...this.closest(".grid__item").querySelectorAll(".accordion details-jb")
    ];

    this.summary = this.querySelector("summary");
    this.content = this.querySelector(".accordion__content");
    this.innerContent = this.querySelector(".inner_content");

    this.height = this.innerContent
      ? this.innerContent.clientHeight + 20 + "px"
      : "0px";
  }

  connectedCallback() {
    if (!this.summary) return;

    this.summary.addEventListener("click", (e) => {
      e.preventDefault();

      const isActive = this.classList.contains("active");

      this.accordions.forEach((item) => {
        item.classList.remove("active");

        const content = item.querySelector(".accordion__content");
        if (content) content.style.height = "0px";
      });


      if (!isActive) {
        this.classList.add("active");

        if (this.content) {
          this.content.style.height = this.height;
        }
      }
    });
  }
}

customElements.define("details-jb", FsDetails);

